import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};

const tomorrowDate = getTomorrowDate();

const internationalDeals = [
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/0961c7b42f2ca80db9f21f3cc92ead20-mjvxq.webp",
    destinations: ["Dubai", "Paris", "Vancouver", "London"],
  },
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/4908135a0884d82aba928cc61ea10829-zxfmm.webp",
    destinations: ["Rome", "Abu Dhabi", "Cape Town", "Seoul"],
  },
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/85a1ec7f8c85db1c8574e407bb5893dc-cgjoa.webp",
    destinations: ["Honolulu", "Frankfurt", "Santorini", "Delhi"],
  },
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/6b26dab0b2ddaefe4a1854e4d0c0aa2b-ymcjd.webp",
    destinations: ["Miami", "Montreal", "Istanbul", "Kuala Lumpur"],
  },
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/01c0f855ac7608f63e6aa1bce4389d5a-wvnvc.webp",
    destinations: ["Singapore", "Shanghai", "Madrid", "Amsterdam"],
  },
  {
    origin: "Georgetown",
    img: "https://images.ixigo.com/image/upload/international-flights/3ad8f80d0c76536dfc29851458881c26-hsphw.webp",
    destinations: ["Los Angeles", "Frankfurt", "Doha", "Auckland"],
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, scale: 0.95, y: 15 },
  visible: { 
    opacity: 1, 
    scale: 1, 
    y: 0,
    transition: { type: "spring", stiffness: 100 }
  }
};

const TopCities = () => {
  return (
    <section style={{ padding: "60px 0", background: "#ffffff" }}>
      <Container>
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="offers-header mb-5"
        >
            <div className="title-area text-md-start">
                <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#053355" }}>Popular <span style={{ color: "#f2bc06" }}>Flight Routes</span></h2>
                <p style={{ color: "#6c757d", marginTop: "5px" }}>Discover the most traveled destinations from Georgetown hub.</p>
            </div>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <Row>
            {internationalDeals.map((item, index) => (
              <Col lg={4} md={6} key={index} className="mb-4">
                <motion.div 
                  variants={cardVariants}
                  whileHover={{ scale: 1.02, boxShadow: "0 10px 25px rgba(0,0,0,0.08)" }}
                  className="flight-route-card d-flex align-items-center" 
                  style={{ 
                    padding: "20px", 
                    gap: "20px", 
                    border: "1px solid #f0f0f0",
                    borderRadius: "16px",
                    background: "#fff",
                    transition: "border-color 0.3s ease"
                  }}
                >
                  <div style={{ width: "80px", height: "80px", borderRadius: "16px", overflow: "hidden", flexShrink: 0 }}>
                    <img loading="lazy" src={item.img} alt={item.origin} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <div>
                    <h3 style={{ fontSize: "17px", fontWeight: "900", color: "#053355", marginBottom: "8px" }}>
                      {item.origin} Flights
                    </h3>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                      <span style={{ fontSize: "12px", color: "#6c757d", fontWeight: "700" }}>To:</span>
                      {item.destinations.map((dest, i) => (
                        <React.Fragment key={i}>
                          <Link 
                            to={`/flightList/org_GEO*dest_${dest.substring(0,3).toUpperCase()}*dep_${tomorrowDate}*arr_${tomorrowDate}*px_1-0-0*jt_1*cbn_2`}
                            style={{ 
                              fontSize: "13px", 
                              color: "#053355", 
                              textDecoration: "none", 
                              fontWeight: "600",
                              transition: "color 0.2s ease"
                            }}
                            className="route-link"
                          >
                            {dest}
                          </Link>
                          {i < item.destinations.length - 1 && <span style={{ color: "#dee2e6" }}>•</span>}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  );
};

export default TopCities;

